/* Printd Knock – temaskript: slider, karusell, mobilmeny, hover-video,
   produktgalleri, variantvelger og AJAX-handlekurv. Ingen avhengigheter. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero-slider */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (!track || track.children.length < 2) return;
    var active = 0;
    var count = track.children.length;

    function goTo(i) {
      active = (i + count) % count;
      track.style.transform = 'translateX(-' + active * 100 + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('bg-sf-ink', di === active);
        d.classList.toggle('bg-sf-ink/25', di !== active);
        d.setAttribute('aria-current', di === active ? 'true' : 'false');
      });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.dataset.heroDot, 10));
      });
    });
    goTo(0);
    if (!reducedMotion) {
      setInterval(function () { goTo(active + 1); }, 6000);
    }
  });

  /* Produktkarusell med piler */
  document.querySelectorAll('[data-carousel]').forEach(function (section) {
    var track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    function scroll(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { scroll(-1); });
    if (next) next.addEventListener('click', function () { scroll(1); });
  });

  /* Mobilmeny */
  var drawerToggle = document.querySelector('[data-drawer-toggle]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  if (drawerToggle && drawer) {
    drawerToggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('hidden') === false;
      drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawerToggle.querySelector('[data-icon-menu]').classList.toggle('hidden', open);
      drawerToggle.querySelector('[data-icon-close]').classList.toggle('hidden', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.classList.contains('hidden')) drawerToggle.click();
    });
  }

  /* Trekkspill i mobilmenyen */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
    var panel = btn.nextElementSibling;
    if (!panel || !panel.hasAttribute('data-accordion-panel')) return;
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('hidden') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Hover-video på produktkort og kategorifliser: har kortet video, vises KUN
     videoen (stillbildet skjules idet avspillingen starter). Kort uten video
     zoomer 10 % via ren CSS (group-hover:scale-110). Kun på enheter med hover. */
  var canHover = window.matchMedia('(hover: hover)').matches;
  document.querySelectorAll('[data-hover-video]').forEach(function (card) {
    var video = card.querySelector('[data-card-video]');
    if (!video || !canHover) return;
    var image = card.querySelector('[data-card-image]');
    var hovering = false;

    function showVideo() {
      if (!hovering) return;
      video.classList.remove('opacity-0');
      video.classList.add('opacity-100');
      if (image) image.classList.add('opacity-0');
    }
    function hideVideo() {
      video.classList.add('opacity-0');
      video.classList.remove('opacity-100');
      if (image) image.classList.remove('opacity-0');
    }

    card.addEventListener('pointerenter', function () {
      if (reducedMotion) return;
      hovering = true;
      var playing = video.play();
      if (playing && typeof playing.then === 'function') {
        playing.then(showVideo).catch(function () {});
      } else {
        showVideo();
      }
    });
    card.addEventListener('pointerleave', function () {
      hovering = false;
      hideVideo();
      video.pause();
      video.currentTime = 0;
    });
  });

  /* Produktgalleri: sveipbar snap-karusell med thumbs (desktop) og prikker (mobil) */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var dots = root.querySelectorAll('[data-gallery-dot]');

    function markActive(idx) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('border-sf-ink', i === idx);
        t.classList.toggle('border-sf-ink/10', i !== idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('bg-sf-ink', i === idx);
        d.classList.toggle('bg-sf-ink/25', i !== idx);
      });
    }
    function goTo(idx) {
      if (!track) return;
      /* scrollTo med behavior:'smooth' henger på snap-mandatory-containere – bruk scrollIntoView */
      var slide = track.children[idx];
      if (slide) slide.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
      markActive(idx);
    }
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          markActive(Math.round(track.scrollLeft / track.clientWidth));
        }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    function stepGallery(dir) {
      if (!track || !track.children.length) return;
      var idx = Math.round(track.scrollLeft / track.clientWidth) + dir;
      idx = Math.max(0, Math.min(track.children.length - 1, idx));
      goTo(idx);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { stepGallery(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepGallery(1); });

    /* Variantvelger: én select per valg – finn varianten som matcher kombinasjonen */
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var idInput = root.querySelector('[data-variant-id]');
    var stickyPrice = root.querySelector('[data-price-sticky]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    var dataEl = root.querySelector('[data-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    /* Knappetekster kommer fra locale-filene via data-attributter på roten */
    var L = {
      add: root.dataset.labelAdd || 'Add to cart',
      addShort: root.dataset.labelAddShort || 'Add to cart',
      soldOut: root.dataset.labelSoldOut || 'Sold out',
      unavailable: root.dataset.labelUnavailable || 'Unavailable',
      rfq: root.dataset.labelRfq || 'Price on request'
    };

    /* Varianter uten pris selges på forespørsel – bytt pris- og knappevisning */
    var priceBlock = root.querySelector('[data-price-block]');
    var rfqBlock = root.querySelector('[data-rfq-block]');
    var quoteLink = root.querySelector('[data-quote-link]');
    var stickyQuote = root.querySelector('[data-sticky-quote]');
    var accBlock = root.querySelector('[data-accessories]');

    /* Tilbehørspanel: «Legg til tilbehør» åpner sidepanelet; valgt tilbehør oppsummeres på knappen */
    var accOpen = root.querySelector('[data-acc-open]');
    var accPanel = root.querySelector('[data-acc-panel]');
    var accSummary = root.querySelector('[data-acc-summary]');
    if (accOpen && accPanel) {
      /* Panelet flyttes til <body> så ingen seksjon/header kan legge seg over det (stablingskontekst) */
      document.body.appendChild(accPanel);
      var accLastFocus = null;
      var accMoney = function (cents) {
        var parts = (cents / 100).toFixed(2).split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' kr';
      };
      var updateAccSummary = function () {
        if (!accSummary) return;
        var checked = accPanel.querySelectorAll('[data-accessory]:checked');
        var sum = 0;
        Array.prototype.forEach.call(checked, function (cb) { sum += parseInt(cb.dataset.accessoryPrice, 10) || 0; });
        var label = (accBlock && accBlock.dataset.labelAccSelected) || '{count} selected';
        accSummary.textContent = label.replace('{count}', checked.length) + ' \u00b7 + ' + accMoney(sum);
        accSummary.classList.toggle('hidden', checked.length === 0);
      };
      var closeAcc = function () {
        if (accPanel.classList.contains('hidden')) return;
        accPanel.classList.add('hidden');
        document.documentElement.classList.remove('overflow-hidden');
        document.documentElement.removeAttribute('data-acc-panel-open');
        accOpen.setAttribute('aria-expanded', 'false');
        if (accLastFocus) accLastFocus.focus();
      };
      accOpen.addEventListener('click', function () {
        accLastFocus = document.activeElement;
        accPanel.classList.remove('hidden');
        document.documentElement.classList.add('overflow-hidden');
        document.documentElement.setAttribute('data-acc-panel-open', '');
        accOpen.setAttribute('aria-expanded', 'true');
        var closeBtn = accPanel.querySelector('button[data-acc-close]');
        if (closeBtn) closeBtn.focus();
      });
      Array.prototype.forEach.call(accPanel.querySelectorAll('[data-acc-close]'), function (el) {
        el.addEventListener('click', closeAcc);
      });
      accPanel.addEventListener('change', updateAccSummary);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAcc();
      });
      updateAccSummary();
    }

    function setRfqState(rfq) {
      if (priceBlock) priceBlock.classList.toggle('hidden', rfq);
      if (rfqBlock) rfqBlock.classList.toggle('hidden', !rfq);
      if (addBtn) addBtn.classList.toggle('hidden', rfq);
      if (stickyAdd) stickyAdd.classList.toggle('hidden', rfq);
      if (stickyQuote) stickyQuote.classList.toggle('hidden', !rfq);
      if (accBlock) accBlock.classList.toggle('hidden', rfq);
      if (quoteLink) {
        quoteLink.classList.toggle('bg-sf-forest', rfq);
        quoteLink.classList.toggle('text-white', rfq);
        quoteLink.classList.toggle('border', !rfq);
        quoteLink.classList.toggle('border-sf-ink', !rfq);
        quoteLink.classList.toggle('hover:text-sf-cream', !rfq);
      }
    }

    function setBuyState(available, label) {
      [addBtn, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = label;
      });
      if (stickyAdd) stickyAdd.textContent = available ? L.addShort : label;
    }

    /* Kaskade: verdier i valg N begrenses av valg 0..N-1 (deaktiveres i menyen). Finnes ikke
       gjeldende verdi lenger, hoppes det til første gyldige – en ekte variant er alltid valgt. */
    function syncSelects() {
      var values = selects.map(function (s) { return s.value; });
      selects.forEach(function (sel, level) {
        var valid = {};
        variants.forEach(function (v) {
          for (var i = 0; i < level; i++) { if (v.options[i] !== values[i]) return; }
          valid[v.options[level]] = true;
        });
        var opts = Array.prototype.slice.call(sel.options);
        opts.forEach(function (o) { o.disabled = !valid[o.value]; });
        if (!valid[sel.value]) {
          var first = opts.filter(function (o) { return !o.disabled; })[0];
          if (first) sel.value = first.value;
        }
        values[level] = sel.value;
      });
      return values;
    }
    function findVariant(values) {
      return variants.filter(function (v) {
        return v.options.length === values.length && v.options.every(function (o, i) { return o === values[i]; });
      })[0];
    }

    /* Spesifikasjoner og trykkmal for valgt variant (fra variant-JSON) */
    var specsSection = root.querySelector('[data-specs]');
    var specsBody = root.querySelector('[data-specs-body]');
    var specsVariant = root.querySelector('[data-specs-variant]');
    var specsFallback = (specsSection && specsSection.hasAttribute('data-specs-fallback') && specsBody) ? specsBody.innerHTML : null;
    function renderSpecs(variant, values) {
      if (!specsSection || !specsBody) return;
      var rows = variant.specs || [];
      if (!rows.length) {
        if (specsFallback !== null) { specsBody.innerHTML = specsFallback; specsSection.classList.remove('hidden'); }
        else specsSection.classList.add('hidden');
        return;
      }
      specsSection.classList.remove('hidden');
      if (specsVariant) specsVariant.textContent = values.join(' / ');
      specsBody.textContent = '';
      rows.forEach(function (r) {
        var row = document.createElement('div'); row.className = 'flex justify-between gap-4 py-3';
        var dt = document.createElement('dt'); dt.className = 'font-bold'; dt.textContent = r[0];
        var dd = document.createElement('dd'); dd.className = 'text-right tabular-nums'; dd.textContent = r[1];
        row.appendChild(dt); row.appendChild(dd); specsBody.appendChild(row);
      });
    }
    var tplLink = root.querySelector('[data-template-link]');
    function renderTemplate(variant) {
      if (!tplLink) return;
      var url = variant.template || '';
      tplLink.classList.toggle('hidden', !url);
      if (url) tplLink.href = url;
    }

    /* Variantstyrt 3D: én 3D-slide med én modell per variant (custom.modell_3d_varianter) – vis modellen til valgt variant */
    var modelSwitch = root.querySelector('[data-model-switch]');
    var modelThumb = root.querySelector('[data-model-thumb]');
    function renderModel(variant) {
      if (!modelSwitch || !variant.model) return;
      var target = modelSwitch.querySelector('[data-model-id="' + variant.model + '"]');
      if (!target || !target.hidden) return;
      Array.prototype.forEach.call(modelSwitch.querySelectorAll('[data-model-id]'), function (el) {
        el.hidden = el !== target;
      });
      if (modelThumb && target.dataset.modelPreview) modelThumb.src = target.dataset.modelPreview;
    }

    function applyVariant(variant, values) {
      if (idInput) idInput.value = variant.id;
      setRfqState(variant.rfq === true);
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.rfq === true ? L.rfq : variant.price;
      if (compareEl) {
        compareEl.textContent = variant.compare || '';
        compareEl.classList.toggle('hidden', !variant.compare);
      }
      if (variant.rfq !== true) setBuyState(variant.available, variant.available ? L.add : L.soldOut);
      renderSpecs(variant, values);
      renderTemplate(variant);
      renderModel(variant);
      if (variant.imageIdx !== null && variant.imageIdx !== undefined) goTo(variant.imageIdx);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    function onVariantChange() {
      var values = syncSelects();
      var variant = findVariant(values);
      if (!variant) {
        /* Skal ikke skje med konsistente data – vis «Utilgjengelig» synlig i stedet for stille feil */
        if (addBtn) addBtn.classList.remove('hidden');
        setBuyState(false, L.unavailable);
        return;
      }
      applyVariant(variant, values);
    }
    selects.forEach(function (s) { s.addEventListener('change', onVariantChange); });
    if (selects.length && variants.length) syncSelects();

    /* Sticky kjøpe-bar på mobil: vis når hovedknappen er ute av syne */
    var stickyBar = root.querySelector('[data-sticky-atc]');
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('translate-y-full', visible);
      }, { rootMargin: '-60px 0px 0px 0px' });
      io.observe(addBtn);
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var form = root.querySelector('form[action*="/cart/add"]');
        if (form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
      });
    }

    /* AJAX legg-i-handlekurv: hovedprodukt + avkrysset tilbehør i ett kall (/cart/add.js, JSON items) */
    var form = root.querySelector('form[action*="/cart/add"]');
    var feedback = root.querySelector('[data-cart-feedback]');
    var errorEl = root.querySelector('[data-cart-error]');
    L.addError = root.dataset.labelAddError || 'Could not add to cart';
    L.accessoryFor = root.dataset.labelAccessoryFor || 'Accessory for';
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput || !idInput.value) return;
        var accessories = Array.prototype.slice.call((accPanel || root).querySelectorAll('[data-accessory]:checked'));
        var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        accessories.forEach(function (cb) {
          var props = {};
          props[L.accessoryFor] = root.dataset.productTitle || '';
          items.push({ id: parseInt(cb.dataset.accessoryId, 10), quantity: 1, properties: props });
        });
        if (addBtn) addBtn.disabled = true;
        if (errorEl) errorEl.classList.add('hidden');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (res.ok) return fetch('/cart.js');
            return res.json().catch(function () { return {}; }).then(function (err) {
              var e2 = new Error(err.description || err.message || 'add-to-cart failed');
              e2.handled = true;
              throw e2;
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var count = document.querySelector('[data-cart-count]');
            if (count) {
              count.textContent = cart.item_count;
              count.classList.toggle('hidden', cart.item_count === 0);
            }
            if (feedback) feedback.classList.remove('hidden');
          })
          .catch(function (err) {
            /* Nettverksfeil uten tilbehør: vanlig innsending. Ellers vises feilen – aldri bare hovedproduktet i det stille. */
            if (!accessories.length && !(err && err.handled)) { form.submit(); return; }
            if (errorEl) {
              errorEl.textContent = (err && err.handled && err.message) || L.addError;
              errorEl.classList.remove('hidden');
            }
          })
          .finally(function () {
            if (addBtn) addBtn.disabled = false;
          });
      });
    }
  });
})();

// cache-bust 2026-09-07 22:00 – variantkaskade, tilbehør, specs/trykkmal
